export const NOTIFICATIONS = {
  CLIENTS: {
    GRAPHQL: {
      ERROR: 'CLIENTS.GRAPHQL.ERROR',
      QUERY: 'CLIENTS.GRAPHQL.QUERY',
    },
  },
  ANALYTICS: {
    INIT: 'ANALYTICS.INIT',
  },
  AUTH: {
    SESSION_LOADED: 'AUTH.SESSION_LOADED',
    SESSION_ERROR: 'AUTH.SESSION_ERROR',
    SIGN_IN_WITH_PASSKEY_SUCCESS: 'AUTH.SIGN_IN_WITH_PASSKEY_SUCCESS',
    SIGN_IN_WITH_PASSKEY_ERROR: 'AUTH.SIGN_IN_WITH_PASSKEY_ERROR',
    SIGN_OUT: 'AUTH.SIGN_OUT',
    AUTHENTICATED: 'AUTH.AUTHENTICATED',
  },
  EVENTS: {
    EVENT: 'EVENTS.EVENT',
    SET_CONTEXT: 'EVENTS.SET_CONTEXT', // Deprecated - kept for backward compatibility
    SET_DEVICE_CONTEXT: 'EVENTS.SET_DEVICE_CONTEXT',
    SET_IDENTITY_CONTEXT: 'EVENTS.SET_IDENTITY_CONTEXT',
    CLEAR_IDENTITY_CONTEXT: 'EVENTS.CLEAR_IDENTITY_CONTEXT',
  },
  LOGGER: {
    DEBUG: 'LOGGER.DEBUG',
    INFO: 'LOGGER.INFO',
    WARN: 'LOGGER.WARN',
    ERROR: 'LOGGER.ERROR',
  },
  FULLSTORY: {
    INIT: 'FULLSTORY.INIT',
  },
  API: {
    CUSTOMER_DETAILS: 'API.CUSTOMER_DETAILS',
  },
  DEVICE: {
    DATA: 'DEVICE.DATA',
  },
  USER_SOURCE: {
    DATA: 'USER_SOURCE.DATA',
  },
  IN_APP_CHAT: {
    OPEN: 'IN_APP_CHAT.OPEN',
    CLOSE: 'IN_APP_CHAT.CLOSE',
  },
  PLATFORM_SERVICE: {
    INIT: 'PLATFORM_SERVICE.INIT',
  },
  PASSKEY_SERVICE: {
    INIT: 'PASSKEY_SERVICE.INIT',
  },
  DEEP_LINKING: {
    APP_URL_OPEN: 'APP_URL_OPEN',
  },
  LIVE_UPDATE: {
    START: 'LIVE_UPDATE.START',
    STOP: 'LIVE_UPDATE.STOP',
  },
  RISK_SERVICE: {
    NO_DEVICE_ID: 'RISK_SERVICE.NO_DEVICE_ID',
  },
  AI_CHAT: {
    AGENT_CHANGED: 'AI_CHAT.AGENT_CHANGED',
  },
  LAUNCH_DARKLY: {
    FLAGS_UPDATED: 'FEATURE_FLAGS.FLAGS_UPDATED',
  },
}
